export const BROWSER_NOOP_ACTIONS = new Set<string>([
  'restartApp',
  'refreshCalendarEvents',
  'saveConversation',
  'updateOpenAtLogin',
  'muteNotificationForHours',
  'muteNotificationPermanently',
  'unmuteNotification',
  'closeSidepanel',
  'updateContextMacro',
  'cancelOngoingContextRequest',
  'toggleWindowClickThrough',
  'focusWindow',
  'typeText',
  'deleteClipboardItem',
  'deleteClipboardByApp',
  'deleteClipboardByDomain',
  'addPrivacyRule',
  'updatePrivacyRule',
  'removePrivacyRule',
  'resetPrivacyFiltersToDefaults',
  'refreshPrivacyDomainMetadata',
  'openSettingsWindow',
  'closeSettingsWindow',
  'openMainWindow',
  'openOnboardingWindow',
])

export const BROWSER_PERMISSION_ACTIONS = new Set<string>([])
